// @flow
export type IncrementAction = {type: "INCREMENT_PRICE_LEVEL", id: number};
export type DecrementAction = {type: "DECREMENT_PRICE_LEVEL", id: number};
export type SetAction = {type: "SET_PRICE_LEVEL", id: number, value: number};
export type SetQuantitiesAction = {type: "SET_NEW_QUANTITIES", quantities: Object};
export type FetchAction = {type: "FETCH_EVENT", data: Object};
export type SetDisplayConfigurationErrorAction = {type: "SET_DISPLAY_CONFIGURATION_ERROR", value: Boolean};

export type Action = IncrementAction | DecrementAction | SetAction | FetchAction | SetQuantitiesAction | SetDisplayConfigurationError;

type State = { +quantities: Object, +indexes: Object, +quantityArrays: Object, +availableQuantities: Object, +initialQuantities: Object, +displayConfigurationError: Boolean };

let initialState = { quantities: {}, indexes: {}, quantityArrays: {}, availableQuantities: {}, initialQuantities: {} , displayConfigurationError: false};

/** Reducer for ticket picker actions */
export function ticketPicker(state: State = initialState, action:Action): State {
    if(action.type === "INCREMENT_PRICE_LEVEL") {
        let id = action.id;
        let quantityArray = state.quantityArrays[action.id];
        let newState = {...state};
        newState.indexes = {...newState.indexes};
        newState.quantities = {...newState.quantities};
        if(newState.indexes[id] === undefined) {
            newState.indexes[id] = 0;
        } else {
            newState.indexes[id] += 1;
        }

        newState.quantities[id] = quantityArray[newState.indexes[id]];

        return newState;
    } else if(action.type === "DECREMENT_PRICE_LEVEL") {
        let id = action.id;
        let quantityArray = state.quantityArrays[action.id];
        let newState = {...state};
        newState.indexes = {...newState.indexes};
        newState.quantities = {...newState.quantities};
        if(newState.indexes[id] === 0) {
            newState.indexes[id] = undefined;
            newState.quantities[id] = undefined;
        } else {
            newState.indexes[id] -= 1;
            newState.quantities[id] = quantityArray[newState.indexes[id]];
        }

        return newState;
    }  else if(action.type === "SET_NEW_QUANTITIES") {
        let newState = {...state};
        newState.availableQuantities = action.quantities;
        return newState;
    } else if(action.type === "SET_PRICE_LEVEL") {
        let newState = {...state};
        newState.indexes = {...newState.indexes};
        newState.quantities = {...newState.quantities};

        let quantityArray = state.quantityArrays[action.id];
        newState.indexes[action.id] = quantityArray.indexOf(action.value);
        newState.quantities[action.id] = quantityArray[newState.indexes[action.id]];
        return newState;
    } else if(action.type === "FETCH_EVENT" || action.type === "REFRESH_EVENT") {
        let newState = {...state};

        for (const eventId in action.data.attributes.events) {
            let levels = action.data.attributes.events[eventId].price_levels;
            if (levels) {
                for(let i = 0; i < levels.length; i++) {
                    let level = levels[i];
                    newState.quantityArrays[level.price_level_id] = buildPriceLevelQuantityArray(level.minimum_purchase_limit, level.transaction_limit, level.increment_by);
                    newState.initialQuantities[level.price_level_id] = buildPriceLevelQuantityArray(level.minimum_purchase_limit, level.transaction_limit, level.increment_by);
                }
            }
        }

        return newState;
    } else if(action.type === "SET_PRICE_LEVELS") {
        let newState = {...state};
        newState.quantityArrays = {};

        for(let i = 0; i < action.data.length; i++) {
            let level = action.data[i];
            newState.quantityArrays[level.price_level_id] = buildPriceLevelQuantityArray(level.minimum_purchase_limit, level.transaction_limit, level.increment_by);
            newState.initialQuantities[level.price_level_id] = buildPriceLevelQuantityArray(level.minimum_purchase_limit, level.transaction_limit, level.increment_by);
        }

        return newState;
    }  else if(action.type === "UPDATE_PRICE_LEVELS") {
        let newState = {...state};

        for(let i = 0; i < action.data.length; i++) {
            let level = action.data[i];
            newState.quantityArrays[level.price_level_id] = buildPriceLevelQuantityArray(level.minimum_purchase_limit, level.transaction_limit, level.increment_by);
        }

        return newState;
    } else if(action.type === "SET_TICKETS") {
        let newState = {...state};
        newState.quantities = {};
        newState.indexes = {};
        return newState;
    } else if(action.type === "RESERVATION_CLEARED" || action.type === "CLEAR_SELECTED_PRICE_LEVELS") {
        if(!action.reset && action.type !== "CLEAR_SELECTED_PRICE_LEVELS") {
            return state;
        }

        let newState = {...state};
        newState.quantities = {};
        newState.indexes = {};
        newState.availableQuantities = {};
        newState.displayConfigurationError = false;
        return newState;
    } else if(action.type === "SET_DISPLAY_CONFIGURATION_ERROR") {
        let newState = {...state};
        newState.displayConfigurationError = action.value ? true : false;
        return newState;
    } else if(action.type === "CHECKOUT_OVERLAY") {
        let newState = {...state};
        if(action.overlay === false) {
            newState.quantities = {};
            newState.indexes = {};
        }
        return newState;
    }else {
        return state;
    }
}

export function buildPriceLevelQuantityArray(min = 0, max = 10, step = 1) {
    if (+min == 0) {
        min = +step;
    }

    let quantities = [];

    for(var i = +min; i <= +max; i += +step) {
        quantities.push(i);
    }

    return quantities;
}
